"use client";

import * as React from "react";

interface SDUIUPLTState {
  refCallback?: React.RefCallback<HTMLElement>;
  numComponents?: number;
  renderNonPrimaryContentPromise: Promise<void>;
}

export const SDUIUPLTContext = React.createContext<SDUIUPLTState>({
  refCallback: emptyRefCallback,
  numComponents: undefined,
  renderNonPrimaryContentPromise: new Promise(() => {}),
});

function emptyRefCallback() {}
